import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap-v5';
import { KTSVG } from '../../../../_mexablock/helpers';

type Props = {
  show: boolean;
  confirmValue: (confirm: boolean) => void;
  onClose?: (closeModal: boolean) => void;
};

const WarModal: React.FC<Props> = ({ show, confirmValue, onClose }) => {
  const [showConfirmationModal, setShowConfirmationModal] = useState(show);

  useEffect(() => {
    setShowConfirmationModal(show);
  }, [show]);

  const handleCancel = () => {
    setShowConfirmationModal(false);
    confirmValue(false);
    if (onClose) {
      onClose(true);
    }
  };

  const handleConfirmation = () => {
    setShowConfirmationModal(false);
    confirmValue(true);
  };

  return (
    <Modal
      show={showConfirmationModal}
      onHide={handleCancel}
      centered
      backdrop="static"
    >
      <Modal.Header className="justify-content-center position-relative">
        <div
          className="btn btn-sm btn-icon btn-active-color-primary position-absolute top-0 end-0 m-3"
          role="button"
          onClick={handleCancel}
        >
          <KTSVG
            className="svg-icon-2"
            path="/media/icons/duotune/arrows/arr061.svg"
          />
        </div>
      </Modal.Header>
      <Modal.Body className="text-center fs-5 fw-bold text-gray-800">
        Existen cambios sin guardar.
        <br />
        ¿Desea continuar editando o abandonar la página y descartar los cambios?
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <button className="btn btn-light" onClick={handleCancel}>
          Continuar editando
        </button>
        <button className="btn btn-primary" onClick={handleConfirmation}>
          Descartar cambios
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export { WarModal };
